<div class="row m-5">
    <div class="col-sm-12 col-md-8">
        <section class="header-wrapper mb-5">
            <h4 class="font-weight-bold x-big-text">
                All Invested Loans
            </h4>
            <span class="text-color-darker-grey">
                Below are the list of loans you have invested in.
            </span>
        </section>
    </div>

    <div *ngIf="loanSettlementNegotiation" class="col-sm-12 col-md-4 text-end">
        <button (click)="getLoanSettlementNegotiationByLenderId()" mat-flat-button
            class="mat-primary mat-flat-button mt-md-5">Refresh data</button>
    </div>

    <div *ngIf="!loanSettlementNegotiation">
        <mat-spinner [diameter]="35" class="mat-spinner center-block"></mat-spinner>
    </div>
    <div class="col-sm-12">
        <ng-container *ngIf="loanSettlementNegotiation">
            <app-loan-settlement-table
                [loanSettlementNegotiation]="loanSettlementNegotiation"></app-loan-settlement-table>
        </ng-container>
    </div>

</div>